import PropTypes from 'prop-types';
import './speakers.css';

export const Speaker = ({ speaker, handleClick }) => {
  console.log(speaker);
  return (
    <div className="snn-speaker-card" onClick={handleClick}>
      <div className="snn-speakers-card-img">
        <img src={speaker.img} alt={speaker.name} />
      </div>
      <div
        className={
          'snn-speakers-card-description snn-user-home-catalysis'
        }
      >
        <h2>{speaker.name}</h2>
        <p>{speaker.affiliation}</p>
      </div>
    </div>
  );
};

Speaker.propTypes = {
  speaker: PropTypes.any,
  handleClick: PropTypes.func,
};
